import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";
import useFacility from "../../../utils/hooks/useFacility";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";
import EAAlert from "../shared/EAAlert";
import { checkComponentActive } from "../../../utils/checkComponentActive";
import { useTranslation } from "react-i18next";

const LimitedTicketColorPage: React.FC = () => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const { colorGroup, requestGetColorGroups } = useTickets();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  useEffect(() => {
    requestGetColorGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  if (checkComponentActive(saleConfiguration.componentList, "Colors") === false) {
    return <EAAlert message={t("Nie znaleziono oferty")} type="error" />;
  }

  return (
    <>
      <div className="container">
        <EAPageHeader componentId="Colors" />
        <EAPageMessage message={saleConfiguration.message_tickets} />

        {colorGroup && (
          <div className="limited-ticket-wrapper">
            {colorGroup.map((item, index) => (
              <LimitedTicketBlock item={item} sortType="colorGroup" key={index} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default LimitedTicketColorPage;
